'use es6';

import PropTypes from 'prop-types';
export const ACTION_STATUSES = {
  NOT_STARTED: 'NOT_STARTED',
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED'
};
export const ActionStatusesPropType = PropTypes.oneOf(Object.values(ACTION_STATUSES));